export type OrganizationLogoRemovedPayload = {
	organizationId: number;
};

export type OrganizationLogoRemovedAction = {
	type: 'ORGANIZATION_LOGO_REMOVED';
	payload: OrganizationLogoRemovedPayload;
};

export default (payload: OrganizationLogoRemovedPayload): OrganizationLogoRemovedAction => ({
	type: 'ORGANIZATION_LOGO_REMOVED',
	payload,
});
